import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBrowseShifts(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path
        stroke="url(#browse-shifts_svg__a)"
        strokeLinecap="round"
        strokeWidth={10}
        d="M67 29.02V14m42 15.02V14m-47 92h52c8.837 0 16-7.163 16-16V37.51c0-8.836-7.163-16-16-16H62c-8.837 0-16 7.164-16 16V90c0 8.837 7.163 16 16 16Z"
      />
      <mask
        id="browse-shifts_svg__b"
        width={44}
        height={43}
        x={101}
        y={55}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M101 55h44v43h-44z" />
        <path d="M130.1 80.14 143 92.638 139.501 96l-12.857-12.529c-4.175 2.789-8.694 3.565-13.51 2.24-3.516-.97-6.305-3.016-8.407-5.95-4.246-5.928-3.454-14.28 1.819-19.36 2.662-2.568 6.182-4.117 9.918-4.366a15.9 15.9 0 0 1 10.433 3.014c6.041 4.4 8.61 13.934 3.203 21.092" />
      </mask>
      <path
        fill="#0D2B57"
        d="M130.1 80.14 143 92.638 139.501 96l-12.857-12.529c-4.175 2.789-8.694 3.565-13.51 2.24-3.516-.97-6.305-3.016-8.407-5.95-4.246-5.928-3.454-14.28 1.819-19.36 2.662-2.568 6.182-4.117 9.918-4.366a15.9 15.9 0 0 1 10.433 3.014c6.041 4.4 8.61 13.934 3.203 21.092"
      />
      <path
        stroke="#fff"
        strokeWidth={2}
        d="M130.1 80.14 143 92.638 139.501 96l-12.857-12.529c-4.175 2.789-8.694 3.565-13.51 2.24-3.516-.97-6.305-3.016-8.407-5.95-4.246-5.928-3.454-14.28 1.819-19.36 2.662-2.568 6.182-4.117 9.918-4.366a15.9 15.9 0 0 1 10.433 3.014c6.041 4.4 8.61 13.934 3.203 21.092Z"
        mask="url(#browse-shifts_svg__b)"
      />
      <path stroke="#0C1C43" d="M51 42.5h74" />
      <defs>
        <linearGradient
          id="browse-shifts_svg__a"
          x1={88}
          x2={88}
          y1={21.51}
          y2={106}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98CCFB" />
          <stop offset={1} stopColor="#E1DDDA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBrowseShifts);
export default ForwardRef;
